export { default as QueryResultTable } from './QueryResultTableWrapper'
